

// ****************** modifier le principe de vrai ou faux *******************
import React, { useState, useEffect } from "react";
import { Modal, Button, Card, List, Input, Checkbox, message, Spin, Progress, Select, Radio, Tag } from "antd";
import { DeleteOutlined, PlusOutlined, EditOutlined, MinusOutlined, InfoCircleOutlined, CheckCircleTwoTone, CloseCircleTwoTone, LoadingOutlined, SaveOutlined, PlusCircleOutlined } from "@ant-design/icons";
import courseService from "../../services/course.service";
import { Editor } from "@tinymce/tinymce-react";
import { useRef } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
// import MatchingQuestionAdmin from "../../";
import MatchingQuestionAdmin from "./MatchingQuestionAdmin";



const { TextArea } = Input;

// const QuizManager = ({ subjectId }) => {
const QuizManager = ({ subjectId, courseId }) => {

    const editorRef = useRef(null);

    const [quizzes, setQuizzes] = useState([]);
    const [selectedQuiz, setSelectedQuiz] = useState(null);
    const [questions, setQuestions] = useState([]);
    const [selectedQuestion, setSelectedQuestion] = useState(null);
    const [answers, setAnswers] = useState([]);
    const [newQuestionText, setNewQuestionText] = useState("");
    const [newAnswerText, setNewAnswerText] = useState("");
    const [isCorrect, setIsCorrect] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [newQuestionExplanation, setNewQuestionExplanation] = useState("");
    const [loading, setLoading] = useState(false);
    const [loadingAnswers, setLoadingAnswers] = useState(false);
    const [loadingUpdate, setLoadingUpdate] = useState(false);
    const [loadingAddAnswer, setLoadingAddAnswer] = useState(false);
    const [loadingAddQuestion, setLoadingAddQuestion] = useState(false);
    const [isQuizModalVisible, setIsQuizModalVisible] = useState(false);
    const [newQuizTitle, setNewQuizTitle] = useState("");
    const [loadingDeleteQuiz, setLoadingDeleteQuiz] = useState(false);
    const [editQuestionId, setEditQuestionId] = useState(null);
    const [editQuestionText, setEditQuestionText] = useState("");
    const [editAnswerId, setEditAnswerId] = useState(null);
    const [editAnswerText, setEditAnswerText] = useState("");
    const [loadingDeleteQuestion, setLoadingDeleteQuestion] = useState(false);
    const [loadingDeleteAnswer, setLoadingDeleteAnswer] = useState(false);
    const [editAnswerState, setEditAnswerState] = useState({});
    const [loadingSaveAnswer, setLoadingSaveAnswer] = useState({});
    const [loadingSaveQuestion, setLoadingSaveQuestion] = useState(false);
    const [loadingQuestionSelection, setLoadingQuestionSelection] = useState(false);
    const [editQuizId, setEditQuizId] = useState(null);
    const [editQuizTitle, setEditQuizTitle] = useState("");
    const [loadingSaveQuiz, setLoadingSaveQuiz] = useState(false);
    const [quizCountsInCertificate, setQuizCountsInCertificate] = useState({});
    const [editQuestionScore, setEditQuestionScore] = useState("");
    const [newQuestionType, setNewQuestionType] = useState("QCU");
    const [editQuestionType, setEditQuestionType] = useState("");
    const [loadingCorrectAnswers, setLoadingCorrectAnswers] = useState({});
    const [correctOrder, setCorrectOrder] = useState([]);
    const [attemptOnce, setAttemptOnce] = useState(false);
    const [matchingLinks, setMatchingLinks] = useState({});
    const [newLeftText, setNewLeftText] = useState("");
    const [newRightText, setNewRightText] = useState("");
    const [subjectTitle, setSubjectTitle] = useState("");


    const handleMatchingSelectChange = (leftId, rightId) => {
        setMatchingLinks(prev => ({ ...prev, [leftId]: rightId }));
    };
    useEffect(() => {
        if (subjectId) {
            courseService.getSubjectById(subjectId).then((res) => {
                setSubjectTitle(res.title || ""); // Assure-toi que l'API retourne un champ `title`
            }).catch(() => {
                setSubjectTitle(""); // En cas d'erreur
            });
        }
    }, [subjectId]);

    useEffect(() => {
        if (selectedQuestion?.questionType === "DRAG_DROP") {
            setCorrectOrder(answers.map(a => a.id));  // ✅ Garde l'ordre initial des réponses
        }
    }, [selectedQuestion, answers]);

    const handleDragEnd = (result) => {
        if (!result.destination) return;

        const reorderedAnswers = [...answers];
        const [movedItem] = reorderedAnswers.splice(result.source.index, 1);
        reorderedAnswers.splice(result.destination.index, 0, movedItem);

        // ✅ Mettre à jour les indices d’ordre
        const updatedAnswers = reorderedAnswers.map((answer, index) => ({
            ...answer,
            order_index: index
        }));

        setAnswers(updatedAnswers);
    };

    const handleConvertToTrueFalse = async () => {
        if (!selectedQuestion) return;

        Modal.confirm({
            title: "Convertir en Vrai/Faux",
            content: "Cela supprimera les anciennes réponses et ne laissera que 'Vrai' et 'Faux'. Continuer ?",
            okText: "Oui, convertir",
            okType: "danger",
            cancelText: "Annuler",
            onOk: async () => {
                setLoading(true);

                try {
                    // Mettre à jour le type de question en "VRAI_FAUX"
                    await courseService.updateQuestion(selectedQuestion.id, {
                        text: selectedQuestion.text,
                        questionType: "VRAI_FAUX"
                    });

                    // Supprimer les anciennes réponses
                    await courseService.deleteAnswersByQuestion(selectedQuestion.id);

                    // Ajouter "Vrai" et "Faux" comme nouvelles réponses
                    const trueAnswer = await courseService.addAnswerToQuestion(selectedQuestion.id, { text: "Vrai", isCorrect: false });
                    const falseAnswer = await courseService.addAnswerToQuestion(selectedQuestion.id, { text: "Faux", isCorrect: false });

                    // Mettre à jour l'état
                    setSelectedQuestion(prev => ({ ...prev, questionType: "VRAI_FAUX" }));
                    setAnswers([trueAnswer, falseAnswer]);

                    message.success("Question convertie en Vrai/Faux !");
                } catch (error) {
                    message.error("Erreur lors de la conversion.");
                }

                setLoading(false);
            }
        });
    };



    const handleSelectCorrectAnswer = async (selectedId) => {
        if (!selectedQuestion) return;

        let updatedAnswers;

        switch (selectedQuestion.questionType) {
            case "VRAI_FAUX":
                // Une seule réponse peut être correcte à la fois
                updatedAnswers = answers.map(a => ({
                    ...a,
                    isCorrect: a.id === selectedId
                }));
                break;

            case "QCU":
                // Seule une réponse correcte est autorisée (Question à Choix Unique)
                updatedAnswers = answers.map(a => ({
                    ...a,
                    isCorrect: a.id === selectedId
                }));
                break;

            case "QCM":
                // Plusieurs réponses peuvent être correctes (Question à Choix Multiple)
                updatedAnswers = answers.map(a =>
                    a.id === selectedId ? { ...a, isCorrect: !a.isCorrect } : a
                );

            case "DRAG_DROP":
                return (
                    <div>
                        {/* Gestion du Drag & Drop */}
                        <DragDropContext onDragEnd={handleDragEnd}>
                            <Droppable droppableId="answers-list">
                                {(provided) => (
                                    <div ref={provided.innerRef} {...provided.droppableProps} style={{ padding: 10, background: "#f8f9fa", borderRadius: 5 }}>
                                        {answers.map((answer, index) => (
                                            <Draggable key={answer.id} draggableId={String(answer.id)} index={index}>
                                                {(provided) => (
                                                    <div
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                        style={{
                                                            padding: 10,
                                                            margin: "5px 0",
                                                            background: "#ffffff",
                                                            border: "1px solid #ddd",
                                                            borderRadius: 5,
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "space-between",
                                                            ...provided.draggableProps.style
                                                        }}
                                                    >
                                                        {answer.text}
                                                        <DeleteOutlined onClick={() => handleDeleteAnswer(answer.id)} style={{ color: "red", cursor: "pointer" }} />
                                                    </div>
                                                )}
                                            </Draggable>
                                        ))}
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        </DragDropContext>

                        {/* ✅ Bouton pour valider l'ordre des réponses */}
                        {selectedQuestion?.questionType === "DRAG_DROP" && (
                            <Button
                                type="primary"
                                onClick={handleValidateDragDropAnswer}
                                style={{ marginTop: 10 }}
                            >
                                Valider l'ordre des réponses
                            </Button>
                        )}
                    </div>
                );



                break;

            default:
                console.warn("Type de question non géré :", selectedQuestion.questionType);
                return;
        }

        setAnswers(updatedAnswers);

        console.log("Réponses mises à jour :", updatedAnswers); // 🔍 Debugging

        // Activer le spinner pour la réponse sélectionnée
        setLoadingCorrectAnswers(prev => ({ ...prev, [selectedId]: true }));

        try {
            const correctAnswerIds = updatedAnswers.filter(a => a.isCorrect).map(a => a.id);
            await courseService.updateCorrectAnswers(selectedQuestion.id, correctAnswerIds);
            message.success("Réponse correcte mise à jour !");
        } catch (error) {
            console.error("Erreur API :", error);
            message.error("Erreur lors de la mise à jour de la réponse correcte.");
        }

        // Désactiver le spinner après la mise à jour
        setLoadingCorrectAnswers(prev => ({ ...prev, [selectedId]: false }));
    };



    const handleUpdateCorrectAnswers = async () => {
        if (!selectedQuestion) return;

        const correctAnswerIds = answers.filter(a => a.isCorrect).map(a => a.id);

        console.log("Données envoyées :", correctAnswerIds); // 🔥 Vérifie ce qui est envoyé

        try {
            await courseService.updateCorrectAnswers(selectedQuestion.id, correctAnswerIds);
            message.success("Réponses mises à jour !");
        } catch (error) {
            console.error("Erreur lors de la mise à jour :", error.response?.data || error.message);
            message.error("Erreur lors de la mise à jour des réponses correctes.");
        }
    };




    const handleSelectCorrectAnswers = async (answerIds) => {
        try {
            await courseService.updateCorrectAnswers(selectedQuestion.id, answerIds);
            message.success("Réponses correctes mises à jour !");
            setAnswers(answers.map(a => ({ ...a, isCorrect: answerIds.includes(a.id) })));
        } catch (error) {
            message.error("Erreur lors de la mise à jour des réponses correctes.");
        }
    };



    // ✅ Gérer la modification du pourcentage
    const handleProgressChange = (quizId, value) => {
        let numericValue = value.replace(",", "."); // Autoriser la virgule aussi
        if (!isNaN(numericValue) && numericValue !== "") {
            setProgressValues((prev) => ({
                ...prev,
                [quizId]: numericValue
            }));
        }
    };



    const handleValidateDragDropAnswer = async () => {
        if (!answers.length) {
            message.error("Aucune réponse à valider !");
            return;
        }

        const orderedAnswerIds = answers.map(a => a.id);

        try {
            await courseService.updateAnswersOrder(selectedQuestion.id, orderedAnswerIds);
            message.success("L'ordre des réponses a été sauvegardé !");
        } catch (error) {
            message.error("Erreur lors de la sauvegarde de l'ordre des réponses.");
            console.error("Erreur API:", error);
        }
    };


    // Rendu des réponses en Drag & Drop
    const renderDragDropAnswers = () => {
        return (
            <div>
                <DragDropContext onDragEnd={handleDragEnd}>
                    <Droppable droppableId="answers-list">
                        {(provided) => (
                            <div ref={provided.innerRef} {...provided.droppableProps} style={{ padding: 10, background: "#f8f9fa", borderRadius: 5 }}>
                                {answers.map((answer, index) => (
                                    <Draggable key={answer.id.toString()} draggableId={answer.id.toString()} index={index}>
                                        {(provided) => (
                                            <div
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                style={{
                                                    padding: 10,
                                                    margin: "5px 0",
                                                    background: "#ffffff",
                                                    border: "1px solid #ddd",
                                                    borderRadius: 5,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "space-between",
                                                    ...provided.draggableProps.style
                                                }}
                                            >
                                                {answer.text}
                                                <DeleteOutlined onClick={() => handleDeleteAnswer(answer.id)} style={{ color: "red", cursor: "pointer" }} />
                                            </div>
                                        )}
                                    </Draggable>
                                ))}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>

                {/* ✅ Bouton pour valider l'ordre des réponses */}
                <Button
                    type="primary"
                    onClick={handleValidateDragDropAnswer}
                    style={{ marginTop: 10 }}
                >
                    Valider l'ordre des réponses
                </Button>
            </div>
        );
    };
    const handleAddDragDropAnswer = () => {
        if (!newAnswerText.trim()) return;

        const newAnswer = { id: Date.now(), text: newAnswerText };
        setAnswers([...answers, newAnswer]);
        setNewAnswerText("");
    };



    // ✅ Appliquer la validation après la modification
    const handleProgressBlur = (quizId) => {
        setProgressValues((prev) => ({
            ...prev,
            [quizId]: Math.max(0, Math.min(100, parseFloat(prev[quizId]) || 0)) // Entre 0 et 100
        }));
    };

    // ✅ Gérer le changement de la checkbox
    const handleQuizCheckboxChange = (quizId, checked) => {
        setQuizCountsInCertificate((prev) => ({
            ...prev,
            [quizId]: checked
        }));
    };




    const renderAnswerInput = () => {
        if (!selectedQuestion) return null;

        switch (selectedQuestion.questionType) {
            case "QCU":
                return (
                    <Radio.Group
                        value={answers.find(a => a.isCorrect)?.id}
                        onChange={(e) => handleSelectCorrectAnswer(e.target.value)}
                    >
                        {answers.map(answer => (
                            <Radio key={answer.id} value={answer.id}>
                                {answer.text}
                            </Radio>
                        ))}
                    </Radio.Group>
                );

            case "QCM":
                return (
                    <Checkbox.Group
                        value={answers.filter(a => a.isCorrect).map(a => a.id)}
                        onChange={(checkedValues) => handleSelectCorrectAnswers(checkedValues)}
                    >
                        {answers.map(answer => (
                            <Checkbox key={answer.id} value={answer.id}>
                                {answer.text}
                            </Checkbox>
                        ))}
                    </Checkbox.Group>
                );

            case "VRAI_FAUX":
                return (
                    // <List
                    //     dataSource={answers}
                    //     renderItem={(answer) => (
                    //         <List.Item actions={[]}>
                    //             <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    //                 <Checkbox
                    //                     checked={answer.isCorrect}
                    //                     onChange={() => handleSelectCorrectAnswer(answer.id)}
                    //                     disabled={loadingCorrectAnswers[answer.id]}
                    //                 />
                    //                 {loadingCorrectAnswers[answer.id] ? (
                    //                     <Spin size="small" />
                    //                 ) : (
                    //                     <>
                    //                         {answer.text}
                    //                         {answer.isCorrect ? (
                    //                             <CheckCircleTwoTone twoToneColor="#52c41a" />
                    //                         ) : (
                    //                             <CloseCircleTwoTone twoToneColor="#ff4d4f" />
                    //                         )}
                    //                     </>
                    //                 )}
                    //                 {/* tu peux ajouter une icône de verrouillage si tu veux */}
                    //             </div>
                    //         </List.Item>
                    //     )}
                    // />

                    <Radio.Group
                        value={answers.find(a => a.isCorrect)?.id}
                        onChange={(e) => handleSelectCorrectAnswer(e.target.value)}
                    >
                        <List
                            dataSource={answers}
                            renderItem={(answer) => (
                                <List.Item>
                                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                        <Radio value={answer.id}>
                                            {answer.text}
                                        </Radio>
                                        {loadingCorrectAnswers[answer.id] ? (
                                            <Spin size="small" />
                                        ) : (
                                            <>
                                                {answer.isCorrect ? (
                                                    <CheckCircleTwoTone twoToneColor="#52c41a" />
                                                ) : (
                                                    <CloseCircleTwoTone twoToneColor="#ff4d4f" />
                                                )}
                                            </>
                                        )}
                                    </div>
                                </List.Item>
                            )}
                        />
                    </Radio.Group>

                );



            case "MATCHING":
                const matchingPairs = [];
                for (let i = 0; i < answers.length; i += 2) {
                    matchingPairs.push({
                        id: answers[i]?.id || Date.now() + i,
                        leftText: answers[i]?.text || "",
                        rightText: answers[i + 1]?.text || ""
                    });
                }

                return (
                    <MatchingQuestionAdmin
                        pairs={matchingPairs}
                        links={matchingLinks}
                        onLinkChange={handleMatchingSelectChange}
                    />
                );


            default:
                return <div>Aucune réponse disponible.</div>;
        }
    };




    const [progressValues, setProgressValues] = useState({});

    const increaseProgress = (quizId) => {
        setProgressValues((prev) => ({ ...prev, [quizId]: Math.min(100, (prev[quizId] || 0) + 10) }));
    };

    const decreaseProgress = (quizId) => {
        setProgressValues((prev) => ({ ...prev, [quizId]: Math.max(0, (prev[quizId] || 0) - 10) }));
    };

    useEffect(() => {
        if (isModalVisible) {
            fetchQuizzes();
        }
    }, [isModalVisible]);


    // const fetchQuizzes = async () => {
    //     setLoading(true);
    //     try {
    //         const response = await courseService.getQuizzesBySubject(subjectId);
    //         const uniqueQuizzes = response.filter((quiz, index, self) =>
    //             index === self.findIndex((q) => q.id === quiz.id)
    //         );

    //         // Met à jour avec des valeurs par défaut
    //         setQuizzes(uniqueQuizzes.map(quiz => ({
    //             ...quiz,
    //             isChecked: quiz.isChecked !== null ? quiz.isChecked : false,  // Valeur par défaut
    //             progressPercentage: quiz.progressPercentage !== null ? quiz.progressPercentage : 0
    //         })));

    //         // 🔥 Initialisation de progressValues avec les valeurs de la base de données
    //         const progressMap = {};
    //         uniqueQuizzes.forEach(quiz => {
    //             progressMap[quiz.id] = quiz.progressPercentage || 0;
    //         });
    //         setProgressValues(progressMap); // Mettre à jour l'état
    //     } catch (error) {
    //         message.error("Erreur lors de la récupération des quizzes.");
    //     }
    //     setLoading(false);
    // };

    const fetchQuizzes = async () => {
        setLoading(true);
        try {
            let response = [];

            if (subjectId) {
                response = await courseService.getQuizzesBySubject(subjectId);
            } else if (courseId) {
                response = await courseService.getQuizzesByCourse(courseId); // 🔁 Crée cette méthode
            } else {
                message.error("Aucun ID de sujet ou de cours fourni.");
                setLoading(false);
                return;
            }

            const uniqueQuizzes = response.filter((quiz, index, self) =>
                index === self.findIndex((q) => q.id === quiz.id)
            );

            setQuizzes(uniqueQuizzes.map(quiz => ({
                ...quiz,
                isChecked: quiz.isChecked !== null ? quiz.isChecked : false,
                progressPercentage: quiz.progressPercentage !== null ? quiz.progressPercentage : 0
            })));

            const progressMap = {};
            uniqueQuizzes.forEach(quiz => {
                progressMap[quiz.id] = quiz.progressPercentage || 0;
            });
            setProgressValues(progressMap);
        } catch (error) {
            message.error("Erreur lors de la récupération des quizzes.");
        }
        setLoading(false);
    };


    const handleDeleteQuestion = async (questionId) => {
        Modal.confirm({
            title: "Êtes-vous sûr de vouloir supprimer cette question ?",
            content: "Cette action est irréversible.",
            okText: "Oui, supprimer",
            okType: "danger",
            cancelText: "Annuler",
            onOk: async () => {
                setLoadingDeleteQuestion(true);
                try {
                    await courseService.deleteQuestion(questionId);
                    message.success("Question supprimée !");
                    setQuestions(questions.filter(q => q.id !== questionId));
                    setSelectedQuestion(null);
                } catch (error) {
                    message.error("Erreur lors de la suppression de la question.");
                }
                setLoadingDeleteQuestion(false);
            },
        });
    };

    const handleEditAnswerClick = (answer) => {
        setEditAnswerState((prevState) => ({
            ...prevState,
            [answer.id]: answer.text, // Stocke le texte de l'ancienne réponse
        }));
    };

    const cancelEditAnswer = (answerId) => {
        setEditAnswerState(prevState => {
            const newState = { ...prevState };
            delete newState[answerId];
            return newState;
        });
    };
    const handleSaveAnswer = async (answerId) => {
        if (!editAnswerState[answerId].trim()) return;

        setLoadingSaveAnswer(prevState => ({ ...prevState, [answerId]: true })); // Active le spinner

        try {
            await courseService.updateAnswer(answerId, { text: editAnswerState[answerId] });
            message.success("Réponse mise à jour !");
            setAnswers(answers.map(a => a.id === answerId ? { ...a, text: editAnswerState[answerId] } : a));
            setEditAnswerState(prevState => {
                const newState = { ...prevState };
                delete newState[answerId];
                return newState;
            });
        } catch (error) {
            message.error("Erreur lors de la mise à jour de la réponse.");
        }

        setLoadingSaveAnswer(prevState => ({ ...prevState, [answerId]: false })); // Désactive le spinner
    };


    const handleEditQuestion = async () => {
        if (!editQuestionText.trim() || !editQuestionId) return;

        // Vérifier que le type de question est bien défini
        if (!editQuestionType || editQuestionType.trim() === "") {
            message.error("Veuillez sélectionner un type de question valide.");
            return;
        }

        setLoadingSaveQuestion(true);

        try {
            await courseService.updateQuestion(editQuestionId, {
                text: editQuestionText,
                score: editQuestionScore,
                questionType: editQuestionType // ✅ Assure-toi que ce champ est bien rempli
            });

            message.success("Question mise à jour !");
            setQuestions(questions.map(q =>
                q.id === editQuestionId
                    ? { ...q, text: editQuestionText, score: editQuestionScore, questionType: editQuestionType }
                    : q
            ));

            setEditQuestionId(null);
            setEditQuestionText("");
            setEditQuestionScore("");
            setEditQuestionType(""); // ✅ Réinitialisation après modification

        } catch (error) {
            message.error("Erreur lors de la mise à jour de la question.");
        }

        setLoadingSaveQuestion(false);
    };

    const questionTypes = [
        { label: "QCU (Choix Unique)", value: "QCU" },
        { label: "QCM (Choix Multiple)", value: "QCM" },
        { label: "Drag & Drop", value: "DRAG_DROP" },
        { label: "Vrai/Faux", value: "VRAI_FAUX" },
        { label: "Matching", value: "MATCHING" }, // ✅ AJOUTE CETTE LIGNE

        // { label: "Ouverte", value: "OUVERTE" },
        // { label: "Code (Programmation)", value: "CODE" }
    ];


    const handleEditAnswer = async () => {
        if (!editAnswerText.trim() || !editAnswerId) return;
        try {
            await courseService.updateAnswer(editAnswerId, { text: editAnswerText });
            message.success("Réponse mise à jour !");
            setAnswers(answers.map(a => a.id === editAnswerId ? { ...a, text: editAnswerText } : a));
            setEditAnswerId(null);
            setEditAnswerText("");
        } catch (error) {
            message.error("Erreur lors de la mise à jour de la réponse.");
        }
    };

    const handleDeleteQuiz = async (quizId) => {
        Modal.confirm({
            title: "Êtes-vous sûr de vouloir supprimer ce quiz ?",
            content: "Cette action est irréversible.",
            okText: "Oui, supprimer",
            okType: "danger",
            cancelText: "Annuler",
            onOk: async () => {
                setLoadingDeleteQuiz(true);
                try {
                    await courseService.deleteQuiz(quizId);
                    message.success("Quiz supprimé !");
                    fetchQuizzes();
                } catch (error) {
                    message.error("Erreur lors de la suppression du quiz.");
                }
                setLoadingDeleteQuiz(false);
            },
        });
    };



    const handleAddQuiz = async () => {
        if (!newQuizTitle.trim()) {
            message.warning("Le titre du quiz est requis.");
            return;
        }

        try {
            const newQuiz = await courseService.addQuizToSubject(subjectId, { title: newQuizTitle, attemptOnce, });
            message.success("Quiz ajouté avec succès !");
            setQuizzes([...quizzes, newQuiz]); // 🔥 Ajout immédiat dans la liste
            setNewQuizTitle("");
            setIsQuizModalVisible(false);
        } catch (error) {
            message.error("Erreur lors de l'ajout du quiz.");
        }
    };

    const handleDeleteAnswer = async (answerId) => {
        Modal.confirm({
            title: "Êtes-vous sûr de vouloir supprimer cette réponse ?",
            content: "Cette action est irréversible.",
            okText: "Oui, supprimer",
            okType: "danger",
            cancelText: "Annuler",
            onOk: async () => {
                setLoadingDeleteAnswer(true);
                try {
                    await courseService.deleteAnswer(answerId);
                    message.success("Réponse supprimée !");
                    setAnswers(answers.filter(a => a.id !== answerId));
                } catch (error) {
                    message.error("Erreur lors de la suppression de la réponse.");
                }
                setLoadingDeleteAnswer(false);
            },
        });
    };

    const handleAddQuestion = async () => {
        if (!newQuestionText.trim() || !selectedQuiz) return;
        setLoadingAddQuestion(true);

        try {
            const newQuestion = await courseService.addQuestionToQuiz(selectedQuiz.id, {
                text: newQuestionText,
                explanation: "",
                questionType: newQuestionType,
                quiz: { id: selectedQuiz.id },
                score: 0
            });

            // 🔥 Ajoute immédiatement la question dans la liste
            setQuestions([...questions, newQuestion]);
            setNewQuestionText("");
            message.success("Question ajoutée avec succès !");

            // ✅ Si c'est une question de type VRAI_FAUX, créer les réponses automatiquement
            if (newQuestionType === "VRAI_FAUX") {
                const vrai = await courseService.addAnswerToQuestion(newQuestion.id, { text: "Vrai", isCorrect: false });
                const faux = await courseService.addAnswerToQuestion(newQuestion.id, { text: "Faux", isCorrect: false });
                setAnswers([vrai, faux]); // Met à jour les réponses dans l'UI
            }

            setSelectedQuestion(newQuestion); // Affiche directement la nouvelle question
        } catch (error) {
            message.error("Erreur lors de l'ajout de la question.");
            console.error("Erreur:", error);
        }

        setLoadingAddQuestion(false);
    };




    const handleSelectQuiz = async (quiz) => {
        setLoading(true);
        setSelectedQuiz(quiz);
        try {
            const response = await courseService.getQuestionsByQuiz(quiz.id);
            setQuestions(response);
            setSelectedQuestion(null);
            setAnswers([]);
        } catch (error) {
            message.error("Erreur lors de la récupération des questions.");
        }
        setLoading(false);
    };


    useEffect(() => {
        if (selectedQuestion) {
            console.log("Requête API pour récupérer les réponses de :", selectedQuestion.id);
            courseService.getAnswersByQuestion(selectedQuestion.id).then(response => {
                console.log("Réponses reçues :", response);
            }).catch(error => {
                console.error("Erreur API réponses :", error);
            });
        }
    }, [selectedQuestion]);



    const handleSelectQuestion = async (question) => {
        setLoadingQuestionSelection(true);
        setLoadingAnswers(true);
        setSelectedQuestion(question);
        setNewQuestionExplanation(question.explanation || "");

        try {
            const response = await courseService.getAnswersByQuestion(question.id);

            // ✅ Vérifie si l'API retourne un champ "order_index" et trie les réponses
            const sortedAnswers = response.sort((a, b) => a.order_index - b.order_index);
            setAnswers(sortedAnswers);
        } catch (error) {
            message.error("Erreur lors de la récupération des réponses.");
        }

        setLoadingAnswers(false);
        setLoadingQuestionSelection(false);
    };


    const handleEditQuizClick = (quiz) => {
        setEditQuizId(quiz.id);
        setEditQuizTitle(quiz.title);
        setAttemptOnce(quiz.attemptOnce || false); // ✅ Synchroniser l'état lors de l'édition

    };


    const handleSaveQuiz = async (quizId) => {
        if (!editQuizTitle.trim()) return;

        setLoadingSaveQuiz(true);

        try {
            // await courseService.updateQuiz(quizId, {
            //     title: editQuizTitle,
            //     isChecked: quizCountsInCertificate[quizId] || false,
            //     progressPercentage: progressValues[quizId] || 0
            // });

            await courseService.updateQuiz(quizId, {
                title: editQuizTitle,
                isChecked: quizCountsInCertificate[quizId] || false,
                progressPercentage: progressValues[quizId] || 0,
                attemptOnce: attemptOnce // ✅ Ajouter cette ligne
            });


            message.success("Quiz mis à jour !");
            // setQuizzes(quizzes.map(q =>
            //     q.id === quizId ? {
            //         ...q,
            //         title: editQuizTitle,
            //         isChecked: quizCountsInCertificate[quizId] || false,
            //         progressPercentage: progressValues[quizId] || 0
            //     } : q
            // ));
            setQuizzes(quizzes.map(q =>
                q.id === quizId ? {
                    ...q,
                    title: editQuizTitle,
                    isChecked: quizCountsInCertificate[quizId] || false,
                    progressPercentage: progressValues[quizId] || 0,
                    attemptOnce: attemptOnce // ✅ pour afficher à jour dans le modal
                } : q
            ));

            setEditQuizId(null);
            setEditQuizTitle("");
        } catch (error) {
            message.error("Erreur lors de la mise à jour du quiz.");
        }

        setLoadingSaveQuiz(false);
    };



    const handleUpdateExplanation = async () => {
        if (!selectedQuestion) return;
        setLoadingUpdate(true);
        try {
            await courseService.updateQuestionExplanation(selectedQuestion.id, newQuestionExplanation);
            message.success("Explication mise à jour !");
        } catch (error) {
            message.error("Erreur lors de la mise à jour de l'explication.");
        }
        setLoadingUpdate(false);
    };


    const handleAddAnswer = async () => {
        if (!newAnswerText.trim() || !selectedQuestion) return;

        // Vérifier que Vrai/Faux ne dépasse pas 2 réponses
        if (selectedQuestion.questionType === "VRAI_FAUX" && answers.length >= 2) {
            message.error("Vous ne pouvez ajouter que deux réponses : Vrai et Faux.");
            return;
        }

        setLoadingAddAnswer(true);
        try {
            const newAnswer = { text: newAnswerText, isCorrect: false }; // Toujours faux au départ
            const savedAnswer = await courseService.addAnswerToQuestion(selectedQuestion.id, newAnswer);

            // 🔥 Ajout immédiat et rafraîchissement des réponses
            setAnswers([...answers, savedAnswer]);
            setNewAnswerText("");

            message.success("Réponse ajoutée avec succès !");
        } catch (error) {
            message.error("Erreur lors de l'ajout de la réponse.");
        }
        setLoadingAddAnswer(false);
    };



    const AddQuestion = async () => {
        if (!newQuestionText.trim() || !selectedQuiz) return;
        setLoadingAddQuestion(true);
        try {
            const newQuestion = await courseService.addQuestionToQuiz(selectedQuiz.id, {
                text: newQuestionText,
                explanation: "",
                questionType: newQuestionType,
            });
            setQuestions([...questions, newQuestion]); // 🔥 Ajout immédiat dans la liste
            setNewQuestionText("");
            message.success("Question ajoutée avec succès !");
        } catch (error) {
            message.error("Erreur lors de l'ajout de la question.");
        }
        setLoadingAddQuestion(false);
    };

    return (
        <div>

            <Button
                type="primary"
                onClick={() => setIsModalVisible(true)}
                icon={<EditOutlined />}
                style={{
                    backgroundColor: "#1890ff", // Bleu
                    borderColor: "#1890ff",
                    color: "white",
                    marginRight: "10px"
                }}
            >
                Gérer les Quizzes
            </Button>

            <Button
                type="primary"
                onClick={() => setIsQuizModalVisible(true)}
                icon={<PlusCircleOutlined />}
                style={{
                    backgroundColor: "#52c41a", // Vert
                    borderColor: "#52c41a",
                    color: "white"
                }}
            >
                Ajouter un Quiz
            </Button>

            <Modal
                title="Ajouter un Quiz"
                visible={isQuizModalVisible}
                onOk={handleAddQuiz}
                onCancel={() => setIsQuizModalVisible(false)}
                okText="Ajouter"
                cancelText="Annuler"
            >
                <Input
                    placeholder="Titre du quiz"
                    value={newQuizTitle}
                    onChange={(e) => setNewQuizTitle(e.target.value)}
                />
            </Modal>


            <Modal
                // title="Gestion des Quizzes"
                title={`Gestion des questions Compris ?  - ${subjectTitle}`}

                visible={isModalVisible}
                onCancel={() => setIsModalVisible(false)}
                footer={[<Button key="close" onClick={() => setIsModalVisible(false)}>Fermer</Button>]}
                width={'95%'}
            >
                <div style={{ display: "flex", gap: "20px" }}>
                    <Card title="Liste des Quizzes" style={{ width: "30%", backgroundColor: "#f8f9fa" }}>
                        {loading ? <Spin indicator={<LoadingOutlined />} /> : null}

                        <List
                            dataSource={quizzes}
                            renderItem={(quiz) => (
                                <List.Item
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between", // Aligner les éléments horizontalement
                                        alignItems: "center", // Centrer verticalement
                                        width: "100%"
                                    }}
                                    // actions={[
                                    //     editQuizId === quiz.id ? (
                                    //         <div style={{ marginTop: "15px", textAlign: "center" }}>
                                    //             <Checkbox
                                    //                 checked={quizCountsInCertificate[quiz.id] || false}
                                    //                 onChange={(e) => handleQuizCheckboxChange(quiz.id, e.target.checked)}
                                    //             >
                                    //                 Quiz compte ou non ?
                                    //             </Checkbox>
                                    //             <Checkbox
                                    //                 checked={attemptOnce}
                                    //                 onChange={(e) => setAttemptOnce(e.target.checked)}
                                    //                 style={{ marginTop: 10 }}
                                    //             >
                                    //                 Le quiz ne peut être tenté qu’une seule fois
                                    //             </Checkbox>
                                    //             {quizCountsInCertificate[quiz.id] && (
                                    //                 <div style={{
                                    //                     backgroundColor: "#f8f9fa",
                                    //                     padding: "10px",
                                    //                     borderRadius: "10px",
                                    //                     display: "flex",
                                    //                     alignItems: "center",
                                    //                     justifyContent: "center",
                                    //                     gap: "15px",
                                    //                     marginTop: "10px"
                                    //                 }}>
                                    //                     <Button.Group>
                                    //                         <Button onClick={() => decreaseProgress(quiz.id)} icon={<MinusOutlined />} style={{ backgroundColor: "red", color: "white" }} />
                                    //                         <Button onClick={() => increaseProgress(quiz.id)} icon={<PlusOutlined />} style={{ backgroundColor: "green", color: "white" }} />
                                    //                     </Button.Group>

                                    //                     <Progress type="circle" percent={progressValues[quiz.id] || 0} style={{ width: "100%" }} />
                                    //                 </div>
                                    //             )}

                                    //             <Input
                                    //                 value={editQuizTitle}
                                    //                 onChange={(e) => setEditQuizTitle(e.target.value)}
                                    //                 style={{ width: "60%", marginTop: "10px" }}
                                    //             />
                                    //             <Input
                                    //                 type="number"
                                    //                 value={progressValues[quiz.id] || 0}
                                    //                 onChange={(e) => handleProgressChange(quiz.id, e.target.value)}
                                    //                 onBlur={() => handleProgressBlur(quiz.id)}
                                    //                 step="0.1"
                                    //                 min="0"
                                    //                 max="100"
                                    //                 style={{
                                    //                     textAlign: "center",
                                    //                     borderColor: "#52c41a",
                                    //                     borderRadius: "5px",
                                    //                     width: "80px"
                                    //                 }}
                                    //                 prefix={<CheckCircleTwoTone twoToneColor="#52c41a" />}
                                    //             />
                                    //             <div style={{ marginTop: "10px", display: "flex", gap: "10px", justifyContent: "center" }}>
                                    //                 <Button
                                    //                     type="primary"
                                    //                     icon={loadingSaveQuiz ? <LoadingOutlined /> : <SaveOutlined />}
                                    //                     onClick={() => handleSaveQuiz(quiz.id)}
                                    //                 >
                                    //                     Enregistrer
                                    //                 </Button>
                                    //                 <Button onClick={() => setEditQuizId(null)} danger>
                                    //                     Annuler
                                    //                 </Button>
                                    //             </div>
                                    //         </div>
                                    //     )


                                    //     : (
                                    //         <>
                                    //             <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                    //                 <span>{quiz.title}</span>
                                    //                 <span style={{ fontWeight: "bold", color: "#007bff" }}>
                                    //                     {quiz.progressPercentage}%
                                    //                 </span>
                                    //             </div>
                                    //             {quiz.attemptOnce && (
                                    //                 <Tag color="red" style={{ marginLeft: 10 }}>Tentative unique</Tag>
                                    //             )}

                                    //         </>
                                    //     )
                                    // ]}

                                    actions={[
                                        editQuizId === quiz.id ? (
                                            <div
                                                style={{
                                                    backgroundColor: "#f0f2f5",
                                                    padding: "15px",
                                                    borderRadius: "10px",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    gap: "12px",
                                                    width: "100%"
                                                }}
                                            >
                                                {/* <Checkbox
                                                    checked={quizCountsInCertificate[quiz.id] || false}
                                                    onChange={(e) => handleQuizCheckboxChange(quiz.id, e.target.checked)}
                                                >
                                                    📊 Quiz compte ou non ???
                                                </Checkbox> */}

                                                <Checkbox
                                                    checked={attemptOnce}
                                                    onChange={(e) => setAttemptOnce(e.target.checked)}
                                                >
                                                    🔐 Une seule tentative autorisée
                                                </Checkbox>

                                                <Input
                                                    value={editQuizTitle}
                                                    onChange={(e) => setEditQuizTitle(e.target.value)}
                                                    placeholder="Titre du quiz"
                                                    prefix={<EditOutlined />}
                                                />

                                                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                    <Progress
                                                        type="circle"
                                                        percent={progressValues[quiz.id] || 0}
                                                        width={60}
                                                    />
                                                    <Input
                                                        type="number"
                                                        value={progressValues[quiz.id] || 0}
                                                        onChange={(e) => handleProgressChange(quiz.id, e.target.value)}
                                                        onBlur={() => handleProgressBlur(quiz.id)}
                                                        min="0"
                                                        max="100"
                                                        addonAfter="%"
                                                        style={{ width: "100px", textAlign: "center" }}
                                                    />
                                                </div>

                                                <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                                                    <Button
                                                        type="primary"
                                                        icon={loadingSaveQuiz ? <LoadingOutlined /> : <SaveOutlined />}
                                                        onClick={() => handleSaveQuiz(quiz.id)}
                                                    >
                                                        Enregistrer
                                                    </Button>
                                                    <Button danger onClick={() => setEditQuizId(null)}>
                                                        Annuler
                                                    </Button>
                                                </div>
                                            </div>
                                        ) : (
                                            <>
                                                <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                                                    <span style={{ fontWeight: "bold", fontSize: 14 }}>{quiz.title}</span>
                                                    <span style={{ color: "#1890ff", fontWeight: "bold" }}>
                                                        {quiz.progressPercentage}%
                                                    </span>
                                                    {quiz.attemptOnce && <Tag color="red">Tentative unique</Tag>}
                                                </div>
                                            </>
                                        )
                                    ]}


                                >
                                    {/* Actions (Sélectionner, Modifier, Supprimer) alignées à droite */}
                                    <div>
                                        <Button type="link" onClick={() => handleSelectQuiz(quiz)}>Sélectionner</Button>
                                        <Button type="link" icon={<EditOutlined />} onClick={() => handleEditQuizClick(quiz)} />
                                        <Button
                                            type="link"
                                            danger
                                            icon={loadingDeleteQuiz ? <LoadingOutlined /> : <DeleteOutlined />}
                                            onClick={() => handleDeleteQuiz(quiz.id)}
                                            disabled={loadingDeleteQuiz}
                                        />
                                    </div>
                                </List.Item>
                            )}
                        />


                    </Card>

                    {selectedQuiz && (
                        <div style={{ display: "flex", flexDirection: "column", width: "65%", gap: "20px" }}>
                            <Card title={`Questions : ${selectedQuiz.title}`} style={{ backgroundColor: "#e3f2fd" }}>
                                {/* <Input
                                    placeholder="Nouvelle question"
                                    value={newQuestionText}
                                    onChange={(e) => setNewQuestionText(e.target.value)}
                                /> */}
                                <Input
                                    placeholder="Nouvelle question"
                                    value={newQuestionText}
                                    onChange={(e) => setNewQuestionText(e.target.value)}
                                    style={{ marginBottom: 10 }}
                                />

                                {/* <Select
                                    style={{ width: "100%", marginBottom: 10 }}
                                    placeholder="Type de Question"
                                    value={newQuestionType}
                                    onChange={(value) => setNewQuestionType(value)}
                                >
                                    <Select.Option value="QCU">Question à choix unique (QCU)</Select.Option>
                                    <Select.Option value="QCM">Question à choix multiple (QCM)</Select.Option>
                                    <Select.Option value="DRAG_DROP">Drag & Drop</Select.Option> {/* ✅ Ajouté ici */}
                                <Select.Option value="VRAI_FAUX">Vrai/Faux</Select.Option>

                                {/* <Select.Option value="VRAI_FAUX">Vrai/Faux</Select.Option>
                                    <Select.Option value="OUVERTE">Réponse ouverte</Select.Option>
                                    <Select.Option value="CODE">Code (Programmation)</Select.Option> */}
                                {/* </Select> */}
                                <Select
                                    style={{ width: "100%", marginBottom: 10 }}
                                    placeholder="Type de Question"
                                    value={newQuestionType}
                                    onChange={(value) => setNewQuestionType(value)}
                                    options={questionTypes}
                                />

                                <Button
                                    type="primary"
                                    icon={loadingAddQuestion ? <LoadingOutlined /> : <PlusCircleOutlined />}
                                    onClick={handleAddQuestion}  // 🔥 Vérifie que c'est bien handleAddQuestion ici !
                                    style={{ marginTop: 10 }}
                                >
                                    Ajouter une Question
                                </Button>


                                <List
                                    dataSource={questions}
                                    renderItem={(question) => (
                                        <List.Item
                                            style={{
                                                cursor: "pointer",
                                                backgroundColor: selectedQuestion?.id === question.id ? "#d3f9d8" : "#e3f2fd",
                                                padding: "10px",
                                                borderRadius: "5px",
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "10px", // ✅ Espacement entre les éléments
                                                flexWrap: "wrap" // ✅ Gérer le responsive
                                            }}
                                            onClick={() => handleSelectQuestion(question)}
                                            actions={[
                                                <Button type="link" icon={<EditOutlined />} onClick={() => {
                                                    setEditQuestionId(question.id);
                                                    setEditQuestionText(question.text);
                                                    setEditQuestionScore(question.score !== null ? question.score : 0);
                                                    setEditQuestionType(question.questionType); // ✅ Assurer la mise à jour du type
                                                }} />,
                                                <Button type="link" danger icon={<DeleteOutlined />} onClick={() => handleDeleteQuestion(question.id)} />
                                            ]}
                                        >
                                            {editQuestionId === question.id ? (
                                                <div style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "space-between",
                                                    width: "100%",
                                                    backgroundColor: "#e6f7ff",
                                                    padding: "10px",
                                                    borderRadius: "8px"
                                                }}>
                                                    {/* 🖊️ Input pour la question */}
                                                    <Input
                                                        value={editQuestionText}
                                                        onChange={(e) => setEditQuestionText(e.target.value)}
                                                        style={{ flex: 2, borderColor: "#1890ff", borderRadius: "5px" }}
                                                        prefix={<EditOutlined style={{ color: "#1890ff" }} />}
                                                    />

                                                    {/* 📌 Sélecteur du type de question */}
                                                    <Select
                                                        value={editQuestionType}
                                                        onChange={(value) => setEditQuestionType(value)}
                                                        style={{ flex: 1, minWidth: "150px" }} // Ajustement de la largeur
                                                        options={questionTypes}
                                                    />

                                                    {/* 🔢 Input pour le score */}
                                                    <Input
                                                        type="number"
                                                        value={editQuestionScore}
                                                        onChange={(e) => setEditQuestionScore(e.target.value)}
                                                        style={{ flex: 1, textAlign: "center", borderColor: "#52c41a", borderRadius: "5px", maxWidth: "80px" }}
                                                        prefix={<CheckCircleTwoTone twoToneColor="#52c41a" />}
                                                    />

                                                    {/* ✅ Boutons Enregistrer & Annuler */}
                                                    <div style={{ display: "flex", gap: "10px" }}>
                                                        <Button
                                                            type="primary"
                                                            onClick={handleEditQuestion}
                                                            icon={loadingSaveQuestion ? <LoadingOutlined /> : <SaveOutlined />}
                                                            style={{ backgroundColor: "#1890ff", borderColor: "#1890ff" }}
                                                        >
                                                            Enregistrer
                                                        </Button>
                                                        <Button
                                                            danger
                                                            onClick={() => setEditQuestionId(null)}
                                                            icon={<CloseCircleTwoTone twoToneColor="#ff4d4f" />}
                                                        >
                                                            Annuler
                                                        </Button>
                                                    </div>
                                                </div>
                                            ) : (
                                                <>
                                                    <span>{question.text}</span>
                                                    <span style={{ fontWeight: "bold", color: "#007bff" }}>
                                                        Score: {question.score !== null ? question.score : 0}
                                                    </span>
                                                    <span style={{ fontWeight: "bold", color: "#d9534f" }}>
                                                        ({question.questionType}) {/* 🔥 Affichage du type */}
                                                    </span>
                                                </>
                                            )}
                                        </List.Item>

                                    )}
                                />



                            </Card>

                            {selectedQuestion && (
                                <>
                                    <Card title={`Explication : ${selectedQuestion.text}`} style={{ backgroundColor: "#e8f5e9" }}>
                                        {/* <TextArea
                                            rows={4}
                                            placeholder="Ajouter une explication"
                                            value={newQuestionExplanation}
                                            onChange={(e) => setNewQuestionExplanation(e.target.value)}
                                        /> */}
                                        <Editor
                                            apiKey="v5a0uyztwrsskf09mpu56qttcqnamjr2l64oxdagfxt9zvle" // Remplace par ta clé API si nécessaire
                                            value={newQuestionExplanation}
                                            // onInit={(evt, editor) => (editorRef.current = editor)}
                                            onInit={(evt, editor) => {
                                                if (editorRef) {
                                                    editorRef.current = editor;
                                                }
                                            }}

                                            onEditorChange={(content) => setNewQuestionExplanation(content)}
                                            init={{
                                                height: 300,
                                                menubar: true,
                                                plugins: [
                                                    "advlist", "autolink", "lists", "link", "image", "charmap", "preview",
                                                    "anchor", "searchreplace", "visualblocks", "code", "fullscreen",
                                                    "insertdatetime", "media", "table", "help", "wordcount"
                                                ],
                                                toolbar: `undo redo | bold italic underline strikethrough | link image media |
        alignleft aligncenter alignright alignjustify | bullist numlist outdent indent |
        removeformat code help`,
                                                content_style: "body { font-family: Arial, Helvetica, sans-serif; font-size: 14px; }",
                                            }}
                                        />

                                        <Button type="primary" onClick={handleUpdateExplanation} style={{ marginTop: 10 }} icon={loadingUpdate ? <LoadingOutlined /> : <SaveOutlined />}>
                                            Mettre à jour l'Explication
                                        </Button>
                                    </Card>

                                    {selectedQuestion && (
                                        <Card title={`Réponses : ${selectedQuestion.text}`} style={{ backgroundColor: "#fff3cd" }}>
                                            {/* {renderAnswerInput()} */}
                                            {selectedQuestion?.questionType === "DRAG_DROP" ? renderDragDropAnswers() : renderAnswerInput()}

                                            {/* // ✅ Problème ici si on affiche aussi des réponses en dessous */}



                                            {loadingAnswers ? <Spin indicator={<LoadingOutlined />} /> : null}




                                            {/* {selectedQuestion?.questionType !== "VRAI_FAUX" && (
                                                <>
                                                    <Input
                                                        placeholder="Ajouter une réponse"
                                                        value={newAnswerText}
                                                        onChange={(e) => setNewAnswerText(e.target.value)}
                                                        style={{ marginBottom: 10 }}
                                                    />
                                                    <Checkbox checked={isCorrect} onChange={(e) => setIsCorrect(e.target.checked)}>
                                                        Correcte ?
                                                    </Checkbox>
                                                    <Button
                                                        type="primary"
                                                        onClick={handleAddAnswer}
                                                        icon={loadingAddAnswer ? <LoadingOutlined /> : <PlusOutlined />}
                                                        style={{ marginTop: 10 }}
                                                    >
                                                        Ajouter une Réponse
                                                    </Button>
                                                </>
                                            )} */}
                                            {selectedQuestion?.questionType === "MATCHING" ? (
                                                <>
                                                    <Input
                                                        placeholder="Texte gauche (question)"
                                                        value={newLeftText}
                                                        onChange={(e) => setNewLeftText(e.target.value)}
                                                        style={{ marginBottom: 8 }}
                                                    />
                                                    <Input
                                                        placeholder="Texte droite (réponse)"
                                                        value={newRightText}
                                                        onChange={(e) => setNewRightText(e.target.value)}
                                                        style={{ marginBottom: 8 }}
                                                    />
                                                    {/* <Button
                                                        type="primary"
                                                        onClick={async () => {
                                                            if (!newLeftText.trim() || !newRightText.trim()) {
                                                                message.warning("Les deux champs sont requis");
                                                                return;
                                                            }
                                                            try {
                                                                const left = await courseService.addAnswerToQuestion(selectedQuestion.id, {
                                                                    text: newLeftText,
                                                                    isCorrect: false
                                                                });

                                                                const right = await courseService.addAnswerToQuestion(selectedQuestion.id, {
                                                                    text: newRightText,
                                                                    isCorrect: false
                                                                });

                                                                setAnswers(prev => [...prev, left, right]);
                                                                setNewLeftText("");
                                                                setNewRightText("");
                                                                message.success("Paire ajoutée !");
                                                            } catch (error) {
                                                                message.error("Erreur lors de l'ajout de la paire");
                                                            }
                                                        }}
                                                        icon={<PlusOutlined />}
                                                    >
                                                        Ajouter la paire
                                                    </Button> */}
                                                    <Button
  type="primary"
  onClick={async () => {
    if (!newLeftText.trim() || !newRightText.trim()) {
      message.warning("Les deux champs sont requis");
      return;
    }

    try {
      // Ajoute la paire
      await courseService.addAnswerToQuestion(selectedQuestion.id, {
        text: newLeftText,
        isCorrect: false,
      });

      await courseService.addAnswerToQuestion(selectedQuestion.id, {
        text: newRightText,
        isCorrect: false,
      });

      // 🔄 Recharge toutes les réponses
      const updatedAnswers = await courseService.getAnswersByQuestion(selectedQuestion.id);
      const sortedAnswers = updatedAnswers.sort((a, b) => a.order_index - b.order_index);
      setAnswers(sortedAnswers);

      // 🔄 (Optionnel) réinitialiser les liens si tu veux un lien auto par défaut :
      const newLinks = {};
      for (let i = 0; i < sortedAnswers.length; i += 2) {
        const left = sortedAnswers[i];
        const right = sortedAnswers[i + 1];
        if (left && right) {
          newLinks[left.id] = right.id;
        }
      }
      setMatchingLinks(newLinks);

      // Réinitialisation des champs
      setNewLeftText("");
      setNewRightText("");
      message.success("Paire ajoutée !");
    } catch (error) {
      message.error("Erreur lors de l'ajout de la paire");
    }
  }}
  icon={<PlusOutlined />}
>
  Ajouter la paireeee
</Button>

                                                </>
                                            ) : (
                                                <>
                                                    <Input
                                                        placeholder="Ajouter une réponse"
                                                        value={newAnswerText}
                                                        onChange={(e) => setNewAnswerText(e.target.value)}
                                                        style={{ marginBottom: 10 }}
                                                    />
                                                    <Checkbox checked={isCorrect} onChange={(e) => setIsCorrect(e.target.checked)}>
                                                        Correcte ?
                                                    </Checkbox>
                                                    <Button
                                                        type="primary"
                                                        onClick={handleAddAnswer}
                                                        icon={loadingAddAnswer ? <LoadingOutlined /> : <PlusOutlined />}
                                                        style={{ marginTop: 10 }}
                                                    >
                                                        Ajouter une Réponse
                                                    </Button>
                                                </>
                                            )}

                                            {selectedQuestion?.questionType === "VRAI_FAUX" && (
                                                <div style={{ marginBottom: 10 }}>
                                                    {/* Cette question est de type <b>Vrai/Faux</b>. Les deux réponses sont déjà générées. */}
                                                </div>
                                            )}


                                        </Card>
                                    )}

                                </>
                            )}
                        </div>
                    )}
                </div>
            </Modal>
        </div>
    );
};

export default QuizManager;

